import { Paper, Avatar, TextField, Button, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import logo from "../../assets/escudo.png";
import Loader from "../../components/loader/loader";
import "./styles.scss";
import RegistrationForm from "../../components/register-form/registerForm";
import EmailConfirmation from "../../components/email-confirmation/emailConfirmation";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../utils/app-routes";

const Singup: React.FC = () => {
  const navigate = useNavigate();
  const [formState, setFormState] = useState(0);
  const [email, setEmail] = useState("");
  const handleConfirRegisterUser = (email: string) => {
    setEmail(email);
    setFormState(1);
  };
  const handleChangeStep = () => {
    setFormState(1);
  };
  return (
    <div className="login_bg flex items-center justify-center w-full h-screen overflow-auto">
      <div className="login_protector"></div>
      <Paper
        className="login_container flex flex-col p-6 max-h-[90vh] overflow-y-auto"
        elevation={3}
      >
        {/* <Avatar alt="Logo Esparza" src={logo} className="logo_container" /> */}

        <Box
          sx={{
            width: 150, // ajusta al diseño
            height: 150,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: "transparent",
          }}
          className="flex-shrink-0 self-center"
        >
          <img
            src={logo}
            alt="Logo Esparza"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
        <h1 className="mb-1 mt-10 text-center">
          <strong>Regístrate</strong>
        </h1>

        <div className="register_form mt-4">
          {formState === 0 && (
            <RegistrationForm
              handleConfirmationCode={handleChangeStep}
              onConfirm={handleConfirRegisterUser}
            />
          )}
          {formState === 1 && (
            <EmailConfirmation
              email={email}
              onConfirm={() => navigate(LOGIN)}
            />
          )}
        </div>
      </Paper>
    </div>
  );
};

export default Singup;
